import { ComponentStyles } from "types/common";

const styles: ComponentStyles = {
  container: {
    display: "flex",
    flexDirection: "row",
    gap: 3,
    width: "100%",
    flexWrap: "wrap",
  },
  viewImageContainer: {
    position: "relative",
    width: {
      sm: "45%",
      xs: "75%",
    },
  },
  viewImage: {
    aspectRatio: "16 / 9",
    objectFit: "contain",
    borderRadius: 3,
    filter: "brightness(0.75)",
  },
  viewIcon: {
    width: "2.2rem",
    height: "2.2rem",
  },
  viewTextContainer: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
  },
};

export default styles;
